document.addEventListener("DOMContentLoaded", function() {
 
  // Helper function to manage cookies
  function setCookie(name, value, days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
  }

  // Function to start the city scene animation
  function startCitySceneAnimation() {
    // Function to move taxi in front of a building
    const moveTaxiToBuilding = (buildingElement) => {
        const buildingRect = buildingElement.getBoundingClientRect();
        const stopPosition = buildingRect.x - document.querySelector(".taxi").getBoundingClientRect().width - 400 - 175;
        gsap.to(".taxi", { x: stopPosition, duration: 14, ease: "power2.out" });
    };

    // Initial setup
    gsap.set(".taxi", { x: "-100%" });
    moveTaxiToBuilding(document.querySelector(".massena")); // Default to .massena

    // Tree animation
    const treeTops = document.querySelectorAll('.trees-container .tree-top');
    treeTops.forEach((treeTop, index) => {
        const paths = treeTop.querySelectorAll('path');
        paths.forEach((path) => {
            const delay = index * 0.2 + Math.random() * 0.3;
            const duration = 2 + Math.random();
            const rotation = Math.random() * 4 - 2; // slight rotation
            const x = Math.random() * 2 - 1; // subtle horizontal movement
            const y = Math.random() * 2 - 1; // subtle vertical movement

            gsap.set(path, { transformOrigin: "50% 50%" });
            gsap.to(path, {
                rotation: rotation,
                x: x,
                y: y,
                duration: duration,
                delay: delay,
                ease: "sine.inOut",
                yoyo: true,
                repeat: -1
            });
        });
    });

    // Fountain animations
    gsap.set(".fountain-water path", { scaleY: 0, transformOrigin: "50% 100%" });
    gsap.to(".fountain-water path", {
        scaleY: 1,
        duration: 0.4,
        ease: "sine.inOut",
        stagger: 0.002,
        yoyo: true,
        repeat: -1
    });

    // Clickable buildings
    const navigateToMassenaLab = () => window.location.href = "https://massenalab.com/";
        const navigateToRoth = () => window.location.href = "https://massenahouse.com/collections/daniel-roth";
    const navigateToKollokium = () => window.location.href = "https://massenahouse.com/pages/kollokium";
    const actualRoth = document.querySelector('.actual-roth');
    const massena = document.querySelector('.massena');
    const kollokium = document.querySelector('.kollokium');
    const kollSign = document.querySelector('.koll-sign');
    actualRoth.addEventListener('click', navigateToRoth);
    massena.addEventListener('click', navigateToMassenaLab);
    // Click on every koll-sign instance (desktop and mobile both have one)
    document.querySelectorAll('.koll-sign').forEach((el) => {
        el.addEventListener('click', navigateToKollokium);
    });
    if (kollokium) {
        kollokium.addEventListener('click', navigateToKollokium);
        kollokium.addEventListener('mouseover', () => moveTaxiToBuilding(kollokium));
    }
    if (kollSign) {
        kollSign.addEventListener('mouseover', () => moveTaxiToBuilding(kollokium));
    }

    // Hover events to move the taxi
    actualRoth.addEventListener('mouseover', () => moveTaxiToBuilding(actualRoth));
    massena.addEventListener('mouseover', () => moveTaxiToBuilding(massena));

    // Mobile clickable buildings
    if (window.matchMedia("(max-width: 749px)").matches) {
        const massenaMobileLink = document.getElementById('massenalab-link');
        const rothMobileLink = document.querySelector('.roth-link');
        const kollMobileLink = document.querySelector('.kollokium-link');
        massenaMobileLink?.addEventListener('click', navigateToMassenaLab);
        rothMobileLink?.addEventListener('click', navigateToRoth);
        kollMobileLink?.addEventListener('click', navigateToKollokium);
    }

    // Function to animate building on hover
    const animateBuildingHover = (buildingElement, filter) => {
        gsap.to(buildingElement, {
            filter: filter,
            duration: 0.3,
            ease: "power1.inOut"
        });
    };

    // Adding hover effects to buildings
    const buildings = document.querySelectorAll('.massena, .actual-roth, .kollokium');
    buildings.forEach(building => {
        building.addEventListener('mouseover', () => animateBuildingHover(building, 'url(#glow-effect)'));
        building.addEventListener('mouseout', () => animateBuildingHover(building, 'none'));
    });
}  function showGateAnimation() {
  const loadingScreen = document.getElementById('loadingScreen');
  if (!loadingScreen) return;

  loadingScreen.style.visibility = 'visible'; // Moved this line
  loadingScreen.style.display = 'flex';
  // Gate animation setup...
  gsap.registerPlugin(DrawSVGPlugin); // Ensure DrawSVGPlugin is loaded and available
  const tl = gsap.timeline({
      onComplete: function() {
          // Hide loading screen and show city scene once animation is complete
          loadingScreen.style.display = 'none';
          setCookie('loadingAnimationPlayed', 'true', 7); // Mark animation as played
          startCitySceneAnimation(); // Start city scene animation
      }
  });

  // Define the timeline animations for the gate opening
  tl.set(".gate-container", { perspective: 500 })
    .set(".gate-container", { yPercent: -50, top: "50%", position: "absolute" })
    .to(".left-gate", { rotationY: 130, scale: 1.2, transformOrigin: "left center", duration: 5, ease: "power2.out" })
    .to(".right-gate", { rotationY: -130, scale: 1.2, transformOrigin: "right center", duration: 5, ease: "power2.out" }, "-=5")
    .fromTo(".logo-gate", { autoAlpha: 0 }, { autoAlpha: 1, duration: 1, ease: "power2.inOut" }, "-=5.5")
    .from(".lines", { drawSVG: "0%", duration: 2, ease: "power2.out" }, "-=4")
    .from(".lines2", { drawSVG: "0%", duration: 2, ease: "power2.out" }, "-=3.5");

  // Make loading screen visible now that everything is set up
  loadingScreen.style.visibility = 'visible';
}
if (getCookie('loadingAnimationPlayed')) {
  const loadingScreen = document.getElementById('loadingScreen');
  if (loadingScreen) {
      loadingScreen.style.display = 'none';
  }
  startCitySceneAnimation(); // Start city scene animation immediately if cookie is present
} else if (document.body.classList.contains('page-index')) {
  // Only when the cookie is not set, we proceed to show the gate animation
  showGateAnimation();
} else {
  // If not the index page or the cookie is set, wait for assets then start the city scene animation
  window.onload = function() {
      startCitySceneAnimation();
  };
}
});


document.addEventListener("DOMContentLoaded", function() {
  
});

document.addEventListener("DOMContentLoaded", function() {
    // Function to handle mobile-specific animation
    function mobileCitySceneAnimation() {
        const taxi = document.querySelector(".taxi");
        if (!taxi) return;
        
        // Setting initial position for mobile
        gsap.set(taxi, { x: '0%' });

      // Function to move taxi to a point just before the end of the tree container on mobile
      function moveTaxiNearTrees() {
        const treesContainer = document.querySelector('.trees-container');
        if (!treesContainer) return;

        const treesRect = treesContainer.getBoundingClientRect();
        const stopPosition = treesRect.right - treesContainer.getBoundingClientRect().width / 2 - taxi.getBoundingClientRect().width; // Adjust stop position as necessary
        gsap.to(taxi, { x: stopPosition, duration: 14, ease: "power2.out" });
    }

    // Start taxi animation by moving it near the tree container
    moveTaxiNearTrees();
}

    // Check if the device is mobile size
    if (window.matchMedia("(max-width: 749px)").matches) {
        mobileCitySceneAnimation(); // Execute the animation specifically for mobile
    } else {
        startCitySceneAnimation(); // Continue with the regular animation for non-mobile devices
    }
});
